module.exports = __webpack_public_path__ + "img/the-year-of-the-witching.d75bfa3a.png";